export default __webpack_public_path__ + "services.b4b4819354526e49cc8794384acc24a6.png";